import {FilterRule} from "../../../components/Filters";
import {DateRange, defaultDateRange} from "../../../components/DateRangePicker";
import {AnalysisEntity, SelectOption, TimeInterval} from "../../../../types";
import {AnalysisViewType} from "./Main/AnalysisViewTypePicker";

export interface State {
    analysisEntity: AnalysisEntity,
    analysisViewType: AnalysisViewType,
    dateRange: DateRange,
    interval: TimeInterval,
    isReadyToFetchReport: boolean
    isNotReadyToFetchLeadsReasons: Array<string>
    ruleGroup: {
        rules: Array<FilterRule>,
    }
    selectedColumns: Array<SelectOption>
}

export enum ActionType {
    SET_ANALYSIS_ENTITY,
    SET_ANALYSIS_VIEW_TYPE,
    SET_DATE_RANGE,
    SET_INTERVAL,
    SET_IS_READY_TO_FETCH_LEADS,
    SET_RULE_GROUP,
    SET_SELECTED_COLUMNS,
}

export interface SetAnalysisEntityAction {
    type: ActionType.SET_ANALYSIS_ENTITY,
    payload: {
        entity: State['analysisEntity'],
    }
}

export interface SetAnalysisViewTypeAction {
    type: ActionType.SET_ANALYSIS_VIEW_TYPE,
    payload: {
        viewType: State['analysisViewType'],
    }
}

export interface SetDateRangeAction {
    type: ActionType.SET_DATE_RANGE,
    payload: {
        dateRange: State['dateRange'],
    }
}

export interface SetIntervalAction {
    type: ActionType.SET_INTERVAL,
    payload: {
        interval: State['interval'],
    }
}

export interface SetIsReadyToFetchLeadsAction {
    type: ActionType.SET_IS_READY_TO_FETCH_LEADS,
    payload: {
        isReadyToFetchLeads: State['isReadyToFetchReport'],
        reasons: State['isNotReadyToFetchLeadsReasons'],
    }
}

export interface SetRuleGroupAction {
    type: ActionType.SET_RULE_GROUP,
    payload: {
        ruleGroup: State['ruleGroup'],
    }
}

export interface SetSelectedColumnsAction {
    type: ActionType.SET_SELECTED_COLUMNS,
    payload: {
        columns: State['selectedColumns'],
    }
}

export type Action =
    | SetAnalysisEntityAction
    | SetAnalysisViewTypeAction
    | SetDateRangeAction
    | SetIntervalAction
    | SetIsReadyToFetchLeadsAction
    | SetRuleGroupAction
    | SetSelectedColumnsAction


export function reducer(state: State, action: Action): State {
    switch (action.type) {
        case ActionType.SET_ANALYSIS_ENTITY:
            return {
                ...state,
                analysisEntity: action.payload.entity,
            };
        case ActionType.SET_ANALYSIS_VIEW_TYPE:
            return {
                ...state,
                analysisViewType: action.payload.viewType,
            };
        case ActionType.SET_DATE_RANGE:
            return {
                ...state,
                dateRange: action.payload.dateRange,
            };
        case ActionType.SET_INTERVAL:
            return {
                ...state,
                interval: action.payload.interval,
            };
        case ActionType.SET_IS_READY_TO_FETCH_LEADS:
            return {
                ...state,
                isReadyToFetchReport: action.payload.isReadyToFetchLeads,
                isNotReadyToFetchLeadsReasons: action.payload.reasons,
            };
        case ActionType.SET_RULE_GROUP:
            return {
                ...state,
                ruleGroup: action.payload.ruleGroup,
            };
        case ActionType.SET_SELECTED_COLUMNS:
            return {
                ...state,
                selectedColumns: action.payload.columns,
            };
    }
}

export const initialState: State = {
    analysisEntity: AnalysisEntity.Leads,
    analysisViewType: AnalysisViewType.Table,
    isReadyToFetchReport: false,
    isNotReadyToFetchLeadsReasons: [],
    ruleGroup: {
        rules: [],
    },
    selectedColumns: [],
    dateRange: defaultDateRange,
    interval: TimeInterval.Day,
}
